import request from '@/utils/request';

//从环境变量获取auth服务的路径
const VUE_APP_ROLE_PATH = process.env.VUE_APP_ROLE_PATH
// 获取路由
export function getRouters(){
    return request({
        url: `${VUE_APP_ROLE_PATH}/menu/getRouters`,
        method: 'get',
        params:{enterprOnly:true}
    });
}